module.exports = __webpack_public_path__ + "static/media/navSearch.b0393ab9.svg";